<template>
   <div id="AppContent">
       <!-- <Header :items="this.$host.items"/> -->
       <Home/>
    <div>
        
        <!-- <div class="d_jump">
            <Main/>
        </div> -->
        <!-- <div class='d_jump'>
            <Banner/>
        </div> -->

        <!--100+商会，组织-->
        <!--<Viewpager/>-->

        <!--<MainBbs/>-->

        <!--<MainPage/>-->


        <!-- <div class="d_jump">
            <AppScheme/>
        </div> -->
        <!--解决方案-->
        <!-- <div class="d_jump">
            <AppSolution/>
        </div> -->
        <!--展示案例-->
        <!-- <div class="d_jump">
            <AppCase/>
        </div> -->

        <!--入驻流程-->
        <!-- <div class="d_jump">
            <AppResidence/>
        </div> -->
        <!--联系我们-->
        <!-- <div class="d_jump">
            <AppContact/>
        </div> -->

        <!--开发流程-->
        <!--<div class="con process-main d_jump" >-->
            <!--<Process />-->
        <!--</div>-->

        <!--关于我们-->

        <!--<div class="con about-main d_jump">-->
            <!--<AboutItem/>-->
        <!--</div>-->
    </div>
       <!--引入脚部-->
       <!-- <Footer /> -->

       <!--返回顶部-->
       <!-- <FloatBtn/> -->
   </div>

</template>
<script>
    // import Header from '../header/app-header.vue'
    import Home from '../home/Home'
    // import Banner from '../banner/app-banner.vue'
    // import Main from '../main/app-main.vue'
    // import Footer from '@/app/common/footer/app-footer.vue'
    // import FloatBtn from '@/app/common/float-btn/app-float.vue'
//    import MainBbs from '../main-bbs/main-bbs.vue'
//    import MainPage from '../main-page/main-page.vue'
//    import AboutItem from '../about/app-about.vue'
//    import Viewpager from '../viewpager/app-viewpager.vue'
    // import AppScheme from '../scheme/app-scheme'
    // import AppCase from '../case/app-case.vue'
    // import AppSolution from '../solution/app-solution.vue'
    // import AppResidence from '../residence/app-residence'
//    import Process from '../process/app-process.vue'
    export default {
//        name: 'AppContent',
        props: {},
        components: {
            // Header,
            Home
            // Main,
            // Banner,
            // Footer,
            // FloatBtn,
//            MainBbs,
//            MainPage,
//            AboutItem,
//            Viewpager,
            // AppCase,
            // AppScheme,
            // AppSolution,
//            Process,
            // AppEnter,
            // AppResidence
        },
        data() {
            return {
//                items:this.$host.items
            }
        },
        methods: {
            // afterLoad: function(anchors, item) {
      // alert(item.index);
    //    $('#myMenu li a').removeClass('active')
    //   if (item.index === 0) {
    //     $('#myMenu li a').eq(item.index).addClass('active')
    //     setTimeout(() => {
    //       $(".title").eq(item.index).addClass("current");
    //     },1000)
    //   } else if (item.index === 1) {
    //     $('#myMenu li a').eq(item.index).addClass('active')
    //     setTimeout(() => {
    //       $(".sectionTwo").addClass("current");
    //     }, 500);
    //   } else if (item.index === 2) {
    //     $('#myMenu li a').eq(item.index).addClass('active')
    //   } else {
    //     $('#myMenu li a').eq(item.index).addClass('active')
    //   }
    },
    //滚动到某一屏之前的回调函数
    // onLeave: function() {
    //   setTimeout(() => {
    //     $(".title").removeClass("current");
    //     $(".sectionTwo").removeClass("current");
    //   },1000);
    // }
    //     }
    }
</script>
<style>

</style>
